import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router";
import { Provider as ReduxProvider } from "react-redux";
import { store } from './store/store'
import { LanguageProvider } from "./contexts/LanguageContext.tsx";
import { Translations } from "./types/index.ts";

const buildLanguage = import.meta.env.VITE_BUILD_LANGUAGE as 'EN' | 'ES';
const translations = import.meta.env.VITE_APP_TRANSLATIONS as Translations || {};

  const basename = import.meta.env.BASE_URL;
  const processedBasename = basename.endsWith('/') && basename !== '/' ? basename.slice(0, -1) : basename;


createRoot(document.getElementById("root")!).render(

  <StrictMode>
    <ReduxProvider store={store}>
      <LanguageProvider initialTranslatedText={translations} initialLanguage={buildLanguage}>
        <BrowserRouter basename={processedBasename}>
          <App />
        </BrowserRouter>
      </LanguageProvider>
    </ReduxProvider>
  </StrictMode>,
);
